import script from "./InputFile.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputFile.vue?vue&type=script&lang=ts&setup=true"

import "./InputFile.vue?vue&type=style&index=0&id=1e3ccfa8&lang=less"

const __exports__ = script;

export default __exports__